import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type OrganisationSettingsRecord = NonNullable<
  ResultOf<typeof organisationSettingsQuery>["currentOrganisation"]
>;

export const organisationSettingsQuery = graphql(`
  query OrganisationSettings {
    currentOrganisation {
      id
      name
      profilePicture {
        ...MediaFields
      }
      contact {
        id
      }
    }
  }
`);

export const updateCurrentOrganisationMutation = graphql(`
  mutation UpdateCurrentOrganisation($input: UpdateCurrentOrganisationInput!) {
    updateCurrentOrganisation(input: $input) {
      id
      name
    }
  }
`);
